<script setup lang="ts">
// Click handler logs to console until the real document-download BFF
// contract lands. Views pass `analyticsKey` so the logged click is
// identifiable — swap the console.info for the real downloader there.

const props = withDefaults(defineProps<{
    label: string;
    // uilib icon name for the left-side circle glyph.
    icon?: string;
    // Optional identifier for telemetry/click logs. Defaults to `label`.
    analyticsKey?: string;
}>(), {
    icon: 'cd-ic-document',
});

const handleClick = () => {
    // eslint-disable-next-line no-console
    console.info('[completion] download requested:', props.analyticsKey ?? props.label);
};
</script>

<template>
    <button class="dlc" type="button" @click="handleClick">
        <span class="dlc__icon">
            <app-icon :icon="icon" />
        </span>
        <span class="dlc__label">{{ label }}</span>
        <span class="dlc__chevron">
            <app-icon icon="cd-ic-download" />
        </span>
    </button>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.dlc {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    background: $white;
    border: 1px solid $portal-border;
    border-radius: $portal-card-radius;
    padding: 12px 16px;
    cursor: pointer;
    transition: background-color 0.15s ease;
    text-align: left;
    font: inherit;
    color: inherit;

    &:hover {
        background: $portal-bg;
    }

    &:focus-visible {
        outline: 2px solid var(--ch-primary, #156FBE);
        outline-offset: 2px;
    }

    &__icon {
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: var(--ch-primary, #156FBE);
        color: $white;
        display: flex;
        align-items: center;
        justify-content: center;

        :deep(svg) {
            width: 20px;
            height: 20px;
        }
    }

    &__label {
        flex: 1;
        min-width: 0;
        font-size: $text-portal-body-lg;
        font-weight: 700;
        color: $portal-text;
        line-height: 1.4;
    }

    &__chevron {
        flex-shrink: 0;
        color: $portal-text-mid;

        :deep(svg) {
            width: 20px;
            height: 20px;
        }
    }
}
</style>
